import { Suspense } from 'react'
import Preloader from '@/components/Preloader'
import type { ChildrenType } from '@/types/component'

const AuthLayout = ({ children }: ChildrenType) => {

  return (
    <Suspense fallback={<Preloader />}>
      {children}
    </Suspense>
  )
}

export default AuthLayout
